import FullscreenOverlay from '@99designs/react-components/components/FullscreenOverlay';

export default FullscreenOverlay;



// WEBPACK FOOTER //
// ./~/@99designs/fullscreen/components/Overlay.js